export default "__VITE_ASSET__DehBCnPW__"